import { get, patch, post, remove } from '@/api/base'
import { i18n } from '@/i18n'

const projectsApi = {
  updateDefaultProjects: async selectedProjects => {
    return await post({
      path: `user/add_default_projects`,
      params: { selected_projects: selectedProjects },
    })
  },
  get: async projectUuid => {
    const response = await get({
      path: `projects/${projectUuid}`,
    })
    return response.success ? response.data.project : null
  },
  getAll: async companyUuid => {
    const response = await get({
      path: 'projects',
      ...(companyUuid && { params: { company_uuid: companyUuid } }),
    })

    return response.success ? response.data.projects : []
  },
  getAllPaginated: async params => {
    const response = await get({
      path: 'projects',
      params: { ...params },
    })

    return response.success
      ? {
          ...response,
          projects: response.data.projects,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  create: async params => {
    const response = await post({
      path: 'projects',
      params,
    })
    return response.success ? response.data.project : null
  },
  update: async (projectUuid, params) => {
    const response = await patch({
      path: `projects/${projectUuid}`,
      params,
    })
    return response.success ? response.data.project : null
  },
  delete: async projectUuid => {
    return await remove({
      path: `projects/${projectUuid}`,
      options: { message: i18n.t('projects.deleted') },
    })
  },
}

export default projectsApi
